import connection from '@/api/connection'

export const loadRacks = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setRackIsLoading', true);
    let url = `/racks`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const racks = res.data.data;
        commit('setRacks', racks);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setRacksPaginated', res.data);
        commit('setRackIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setRackIsLoading', false);
      });
}

export const rackById = async ({ commit }, id) => {
  commit('setRackIsLoading', true);
  await connection.get(`/racks/${id}`)
    .then(res => {
      commit('setRackDetail', res.data.data);
      commit('setRackIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRackIsLoading', false);
    });
}

export const storeRack = async ({ commit }, rack) => {
  commit('setRackIsCreating', true);
  await connection.post(`/racks/create`, rack)
    .then(res => {
      commit('saveNewRacks', res.data);
      commit('setRackIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRackIsCreating', false);
    });
}

export const updateRack = async ({ commit }, rack ) => {
  commit('setRackIsUpdating', true);
  await connection.put(`/racks/${rack.id}/update`, rack)
    .then(res => {
      commit('saveUpdatedRack', res.data);
      commit('setRackIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRackIsUpdating', false);
    });
}

export const deleteRack = async ({ commit }, rack) => {
  commit('setRackIsDeleting', true);
  await connection.delete(`/racks/${rack.id}/delete`)
    .then(res => {
      commit('setDeleteRack', res.data);
      commit('setRackIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRackIsDeleting', false);
    });
}